import { createPostEndpoint } from '@sonar-software/sonar-http';

type TaskOrder = {
	initiativeTaskId: number;
	orderIndex: number;
};

export type PostInitiativeTaskOrderRequest = {
	initiativeId: number;
	initiativeTaskOrder: Array<TaskOrder>;
};

export const postInitiativeTaskOrder = createPostEndpoint<PostInitiativeTaskOrderRequest>(
	({ initiativeId }) => `/api/v2/initiatives/${initiativeId}/tasks/order-tasks`
);
